import {newAxios} from './index'
import { Enum_UpdateCustomer } from '@/util/paramsConfig'
import { filterProp } from '@/util'
export const Req_GetClientList = function (data) {
  return newAxios({
    url: `/i/tenant/crm/customer/list`,
    data
  })()
}

export const Req_GetTagList = function (data) {
  return newAxios({
    url: '/tagList',
    data
  })()
}

export const Req_SaveClientInfo = function (data) {
  return newAxios({
    url: '/saveClientInfo',
    data
  })()
}

export const Req_GetClientContract = function (data) {
  return newAxios({
    url: `/i/tenant/crm/customer/pact/list`,
    data
  })()
}

export const Req_GetCustomerContract = function (data) {
  return newAxios({
    url: '/getCustomerContract',
    data
  })()
}

export const Req_CreateCustomer = function (data) {
  return newAxios({
    url: `/i/tenant/crm/customer/add`,
    data
  },'json')()
}

export const Req_GetCustomerInfo = function (data) {
  return newAxios({
    url: `/i/tenant/crm/customer/info/management/${data.id}`
  })()
}

export const Req_GetCustomerLevels = function (data) {
  return Promise.resolve()
}

export const Req_UpdateCustomer = function (data) {
  return newAxios({
    url: `/i/tenant/crm/customer/update`,
    data: filterProp(Enum_UpdateCustomer,data)
  },'json')()
}

export const Req_UpdateBusinessInfo = function (data) {
  return newAxios({
    url: `/i/tenant/crm/customer/commercial/update`,
    data
  },'json')()
}

export const Req_UpdateTaxInfo = function (data) {
  return newAxios({
    url: `/i/tenant/crm/customer/taxbureau/update`,
    data
  },'json')()
}

export const Req_AddCusContact = function (data) {
  return newAxios({
    url: `/i/tenant/crm/customer/contact/add`,
    data
  },'json')()
}

export const Req_UpdateCusContact = function (data) {
  return newAxios({
    url: `/i/tenant/crm/customer/contact/update`,
    data
  },'json')()
}

export const Req_DeleteCusContact = function (data) {
  console.log(data)
  return newAxios({
    url: `/i/tenant/crm/customer/contact/delete/${data.contactId}`
  })()
}
/**新增证照 */
export const Req_AddCredential = function (data) {
  return newAxios({
    url: `/i/tenant/crm/customer/attachment/add`,
    data
  },'json')()
}
/**删除证照 */
export const Req_DeleteCredential = function (data) {
  return newAxios({
    url: `/i/tenant/crm/customer/attachment/delete/${data.id}`
  })()
}

//修改证照
export const Req_UpdateCredential = function(data) {
  return newAxios({
    url:`/i/tenant/crm/customer/attachment/update`,
    data
  },'json')()
}

export const Req_DeleteCustomer = function (data) {
  return newAxios({
    url:`/i/tenant/crm/customer/delete`,
    data
  },'json')()
}

export const Req_GetAllCustomers = function (data) {
  return newAxios({
    url:`/i/tenant/crm/customer/all/customers`,
    data
  })()
}

export const Req_GetCustomerShiftList = function (data){
  return newAxios({
    url:`/i/tenant/crm/customer/list/for/shift`,
    data
  })()
}

export const Req_submitCrmCustomerShift = function (data) {
  return newAxios({
    url:`/i/tenant/crm/customer/shift`,
    data,
  })()
}

export const Req_getExportFinanceExcelData = function (data) {
  return newAxios({
    url:`/i/tenant/finance/teller/export/finance/excel`,
    data
  })()
}

export const Req_SetTaxGovProxyAccount = data => {
  return newAxios({
    url: `/i/tenant/crm/customer/proxy/tax/account/batch/setting`,
    data
  })
}


// WEBPACK FOOTER //
// ./src/request/customer.js